import { render, staticRenderFns } from "./customize-class-groups.vue?vue&type=template&id=fdc72dea&scoped=true&"
import script from "./customize-class-groups.ts?vue&type=script&lang=ts&"
export * from "./customize-class-groups.ts?vue&type=script&lang=ts&"
import style0 from "./customize-class-groups.scss?vue&type=style&index=0&id=fdc72dea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc72dea",
  null
  
)

export default component.exports